import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=721541e2&scoped=true&lang=html"
var script = {}
import style0 from "./Header.vue?vue&type=style&index=0&id=721541e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721541e2",
  null
  
)

export default component.exports